import React__default, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import tokens from '@te-digi/styleguide-tokens';

const StyledDiv = styled.div.withConfig({
  componentId: "sg1510__sc-19xe6wp-0"
})(["margin-left:auto;margin-right:auto;max-width:", ";padding-left:16px;padding-right:16px;width:100%;"], props => props.$size ? tokens.breakpoint[props.$size] : '1140px');
const Container = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    className,
    size
  } = _ref;
  return /*#__PURE__*/React__default.createElement(StyledDiv, {
    $size: size,
    className: className,
    ref: ref
  }, children);
});
Container.displayName = 'Container';
Container.propTypes = {
  /**
   * Content of the component.
   */
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl'])
};

export { Container };
